import { validateEachLanguage } from "@dgs/core";
import { TFunction } from "i18next";
import { EventTypeBaseFormValues, EventTypeSettingsFormValues } from "../shared/types/eventType";

export function eventTypeValidation(t: TFunction) {
	return (values: EventTypeBaseFormValues) => {
		const errors: { [K in keyof EventTypeBaseFormValues]?: any } = {};

		if (!values.eventRole) {
			errors.eventRole = t("Required field");
		}

		if (!values.fallbackLanguage) {
			errors.fallbackLanguage = t("Required field");
		}

		if (values.allowedVisibilities.length === 0) {
			errors.allowedVisibilities = t("At least one visibility option must be selected");
		}

		return {
			...errors,
			...validateEachLanguage<EventTypeBaseFormValues["translations"][number]>(
				values.translations,
				(_, translation) => {
					const errors: Record<string, any> = {};
					if (!translation.name) {
						errors.name = t("Field is required");
					}
					return errors;
				},
			),
		};
	};
}

export function eventTypeSettingsValidation(t: TFunction) {
	return (values: EventTypeSettingsFormValues) => {
		const errors: { [K in keyof EventTypeSettingsFormValues]?: any } = {};

		if (!values.eventCategoryRequirement) {
			errors.eventCategoryRequirement = t("Required field");
		}

		return errors;
	};
}
